import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteDocument = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}delete_document/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteDocument;
